/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as Types from '../../graphql.generated'

const defaultOptions = {} as const
export type GetPatientHistoryPrefillDataQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  type: Types.PatientHistoryType
  callID?: Types.InputMaybe<Types.Scalars['ID']['input']>
}>

export type GetPatientHistoryPrefillDataQuery = {
  __typename?: 'Query'
  patientHistoryPrefillData: { __typename?: 'PatientHistoryPrefillData'; value: Types.JSONObject }
}

export const GetPatientHistoryPrefillDataDocument = gql`
  query getPatientHistoryPrefillData($uid: ID!, $type: PatientHistoryType!, $callID: ID) {
    patientHistoryPrefillData(uid: $uid, type: $type, callID: $callID) {
      value
    }
  }
`

/**
 * __useGetPatientHistoryPrefillDataQuery__
 *
 * To run a query within a React component, call `useGetPatientHistoryPrefillDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientHistoryPrefillDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientHistoryPrefillDataQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      type: // value for 'type'
 *      callID: // value for 'callID'
 *   },
 * });
 */
export function useGetPatientHistoryPrefillDataQuery(
  baseOptions: Apollo.QueryHookOptions<GetPatientHistoryPrefillDataQuery, GetPatientHistoryPrefillDataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPatientHistoryPrefillDataQuery, GetPatientHistoryPrefillDataQueryVariables>(
    GetPatientHistoryPrefillDataDocument,
    options
  )
}
export function useGetPatientHistoryPrefillDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPatientHistoryPrefillDataQuery,
    GetPatientHistoryPrefillDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetPatientHistoryPrefillDataQuery, GetPatientHistoryPrefillDataQueryVariables>(
    GetPatientHistoryPrefillDataDocument,
    options
  )
}
export type GetPatientHistoryPrefillDataQueryHookResult = ReturnType<typeof useGetPatientHistoryPrefillDataQuery>
export type GetPatientHistoryPrefillDataLazyQueryHookResult = ReturnType<
  typeof useGetPatientHistoryPrefillDataLazyQuery
>
export type GetPatientHistoryPrefillDataQueryResult = Apollo.QueryResult<
  GetPatientHistoryPrefillDataQuery,
  GetPatientHistoryPrefillDataQueryVariables
>
